import * as React from "react";

import styles from "./MenuPage.module.scss";

import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Alert, AlertTitle, Button } from "@mui/material";

//data table
import { MDBDataTable } from "mdbreact";
import { IBaseModel } from "../../interfaces/base";
import { API_INTEGRATION_ID } from "../../config";
import {
  getMenuList,
  updateMenu,
  uploadBulkMenu,
  //uploadBulkMenuToPartner,
} from "../../redux/actions/menu/menuActions";
import {
  IPartnerMenuItem,
  IPartnerMenuItemRequestModel,
  IPartnerMenuItemUpdateRequestModel,
} from "../../interfaces/menu";

import LoadingComponent from "../loadingComponent/LoadingComponent";
//import PartnerMenu from "./components/partnerMenuPopup/PartnerMenu";
import { useHistory } from "react-router";
import {
  BULK_UPLOAD_RESET,
  UPDATE_ITEM_RESET,
} from "../../redux/actions/types";

import { UpgradeOutlined } from "@mui/icons-material";
//import { borderRadius } from "@mui/system";
//import { CircularProgress, FormGroup } from "@material-ui/core";
//import ToggleSwitch from "./components/toggleSwitch/ToggleSwitch";
import { Spinner } from "reactstrap";
//import axios from "axios";
import apis from "../../api/apis";
//import { start } from "repl";
//import { APIResponseType } from "../../config/enumApiResponseTypes";

/* const navItems = [
  {
    orderType: "UberEats",
    orderTypeName: "Uber Eats",
  },
  {
    orderType: "PickMeFood",
    orderTypeName: "Pickme Food",
  },
  {
    orderType: "BLXECommerce",
    orderTypeName: "BLX ECommerce",
  },
]; */

let initialLoaded = true;

const MenuPage = (): JSX.Element => {
  //const [toggleUberMenu, settoggleUberMenu] = useState(false)
  //const [newMenuList, setnewMenuList] = useState([])
  // const [isPartnerAvailable, setisPartnerAvailable] = useState<boolean>(false)
  // const [isDiscontinuedItem, setisDiscontinuedItem] = useState<boolean>(false)

  //let updateItemList: any = [];
  const [updateItemList, setupdateItemList] = useState<any>([]);
  const [isItemsLoading, setIsItemsLoading] = useState<boolean>(false);
  //console.log("updateItemList");
  // console.log("updateItemList " + isItemsLoading);

  //const [discontinueChanged, setdiscontinueChanged] = useState<boolean>(false);
  //const [partnerChanged, setpartnerChanged] = useState<boolean>(false);

  //const [itemCode, setItemCode] = useState<String>("");
  const [itemCodeDiscontinue, setItemCodeDiscontinue] = useState<String>("");

  const [isProcessing, setisProcessing] = useState<boolean>(false);

  const [isAllSelected, setIsAllSelected] = useState<boolean>(false);
  // const [isDisabled, setisDisabled] = useState<boolean>();
  //console.log(isAllSelected)

  const [itemsToDisplay, setitemsToDisplay] = useState<
    IPartnerMenuItem[] | undefined
  >();
  //const [itemsToUpload, setitemsToUpload] = useState<any>();
  //console.log("itemsToDisplay");
  // console.table(itemsToDisplay);

  //const [bulkUploadAll, setBulkUploadAll] = useState<any>([]);

  // console.log("bulkUploadAll")
  // console.log(bulkUploadAll)

  const history = useHistory();

  const dispatch = useDispatch();
  const { isAllMenuLoading, menuItems } = useSelector(
    (state: any) => state.getAllMenuReducer
  );
  //console.log(menuItems);
  // console.log("menuItems")
  // console.log(menuItems.length)

  // const filterItems = ()=>{

  //   setallItems((items:any)=>
  //   items.map((item:any)=>({
  //       ...item,
  //       ItemImage:null
  //     })))
  // }bulkUploadPartnerReducer

  const { isMenuUploaded, isMenuUploading, isUploadFailed } = useSelector(
    (state: any) => state.bulkUploadReducer
  );

  // const { isMenuUploadedPartner, isMenuUploadingPartner } = useSelector(
  //   (state: any) => state.bulkUploadPartnerReducer
  // );
  //console.log("bulkUploaded");
  //console.log(isMenuUploaded);

  const { isMenuUpdated, updatedItem, isUpdating, updateFailed } = useSelector(
    (state: any) => state.updateMenuReducer
  );
  const { user } = useSelector((state: any) => state.authentication);

  // const getMenuHandler = () => {
  //   const data: IBaseModel = {
  //     RequestId: API_INTEGRATION_ID,
  //     IntegrationId: API_INTEGRATION_ID,
  //     ApiKey: "",
  //     UID: {
  //       CompanyKey: user?.CompanyKey ?? 0,
  //       LocationKey: user?.LocationKey ?? 0,
  //       UserKey: user?.UserKey ?? 0,
  //     },
  //     RequestingUser: 0,
  //     RequestingId: "",
  //     Schema: "",
  //     ValidationMessages: [],
  //     IsApprovedStatus: 0,
  //     IsActive: 0,
  //   };
  //   dispatch(getMenuList(data));
  // };

  const filterMenuToUpload = async () => {
    // console.log("1");
    setIsItemsLoading(true);

    //let newFilteredList: any = [];
    const data: IBaseModel = {
      RequestId: API_INTEGRATION_ID,
      IntegrationId: API_INTEGRATION_ID,
      ApiKey: "",
      UID: {
        CompanyKey: user?.CompanyKey ?? 0,
        LocationKey: user?.LocationKey ?? 0,
        UserKey: user?.UserKey ?? 0,
        EnvironmentName: user?.EnvironmentName ?? 0,
        IsUrbanPiper: user?.IsUrbanPiper ?? false,
      },
      RequestingUser: 0,
      RequestingId: "",
      Schema: "",
      ValidationMessages: [],
      IsApprovedStatus: 0,
      IsActive: 0,
    };

    const { ResponseData } = await apis.Menus.getMenuItemList(data);

    //const newList = ResponseData.MenuItemList.forEach((x)=>x.ItemImage === null)
    setitemsToDisplay(ResponseData.MenuItemList);

    setIsItemsLoading(false);

    // if (ResponseData.MenuItemList.length > 0) {
    //   for (let index = 0; index < ResponseData.MenuItemList.length; index++) {
    //     let newItem: IPartnerMenuItem = {
    //       ItemKey: ResponseData.MenuItemList[index].ItemKey,
    //       ItemName: ResponseData.MenuItemList[index].ItemName,
    //       ItemCode: ResponseData.MenuItemList[index].ItemCode,
    //       ItemShortName: ResponseData.MenuItemList[index].ItemShortName,
    //       CategoryName: ResponseData.MenuItemList[index].CategoryName,
    //       CategoryCode: ResponseData.MenuItemList[index].CategoryCode,
    //       ItemImageUrl: ResponseData.MenuItemList[index].ItemImageUrl,
    //       ItemImage: ResponseData.MenuItemList[index].ItemImage,
    //       // ItemImage: null,
    //       Description: ResponseData.MenuItemList[index].Description,
    //       SalesPrice: ResponseData.MenuItemList[index].SalesPrice,
    //       IsDiscontinued: ResponseData.MenuItemList[index].IsDiscontinued,
    //       IsAgeVerification: ResponseData.MenuItemList[index].IsAgeVerification,
    //       IsPartnerItem: ResponseData.MenuItemList[index].IsPartnerItem,
    //     };

    //     newFilteredList.push(newItem);

    //     // console.log("pushed")
    //   }

    //   //console.log("newList")

    //   // setBulkUpload(newFilteredList);
    //   setitemsToDisplay(newFilteredList);
    //   // console.log("display length")
    //   // console.log(itemsToDisplay.length)
    // }

    //console.log(bulkUpload)
    // menuItemArray.push(filterMenuToUpload)
  };

  //upload all menu
  // const bulkUploadAllMenu = async () => {
  //   let allMenuList: any = [];
  //   const data: IBaseModel = {
  //     RequestId: API_INTEGRATION_ID,
  //     IntegrationId: API_INTEGRATION_ID,
  //     ApiKey: "",
  //     UID: {
  //       CompanyKey: user?.CompanyKey ?? 0,
  //       LocationKey: user?.LocationKey ?? 0,
  //       UserKey: user?.UserKey ?? 0,
  //     },
  //     RequestingUser: 0,
  //     RequestingId: "",
  //     Schema: "",
  //     ValidationMessages: [],
  //     IsApprovedStatus: 0,
  //     IsActive: 0,
  //   };

  //   const { ResponseData } = await apis.Menus.getMenuItemList(data);

  //   if (ResponseData.MenuItemList.length > 0) {
  //     for (let index = 0; index < ResponseData.MenuItemList.length; index++) {
  //       let newItem: IPartnerMenuItem = {
  //         ItemKey: ResponseData.MenuItemList[index].ItemKey,
  //         ItemName: ResponseData.MenuItemList[index].ItemName,
  //         ItemCode: ResponseData.MenuItemList[index].ItemCode,
  //         ItemShortName: ResponseData.MenuItemList[index].ItemShortName,
  //         CategoryName: ResponseData.MenuItemList[index].CategoryName,
  //         CategoryCode: ResponseData.MenuItemList[index].CategoryCode,
  //         ItemImageUrl: ResponseData.MenuItemList[index].ItemImageUrl,
  //         ItemImage: null,
  //         Description: ResponseData.MenuItemList[index].Description,
  //         SalesPrice: ResponseData.MenuItemList[index].SalesPrice,
  //         IsDiscontinued: ResponseData.MenuItemList[index].IsDiscontinued,
  //         IsAgeVerification: ResponseData.MenuItemList[index].IsAgeVerification,
  //         IsPartnerItem: true,
  //       };

  //       allMenuList.push(newItem);

  //       //console.log("pushed")
  //     }
  //   }
  //   //console.log(allMenuList)
  // };

  // useEffect(() => {
  //   if (initialLoaded) {
  //     const data: IBaseModel = {
  //       RequestId: API_INTEGRATION_ID,
  //       IntegrationId: API_INTEGRATION_ID,
  //       ApiKey: "",
  //       UID: {
  //         CompanyKey: user?.CompanyKey ?? 0,
  //         LocationKey: user?.LocationKey ?? 0,
  //         UserKey: user?.UserKey ?? 0,
  //         EnvironmentName: user?.EnvironmentName ?? 0,
  //         IsUrbanPiper: user?.IsUrbanPiper ?? false,
  //       },
  //       RequestingUser: 0,
  //       RequestingId: "",
  //       Schema: "",
  //       ValidationMessages: [],
  //       IsApprovedStatus: 0,
  //       IsActive: 0,
  //     };
  //     dispatch(getMenuList(data));

  //     initialLoaded = false;
  //   }
  // }, [
  //   dispatch,
  //   user?.CompanyKey,
  //   user?.EnvironmentName,
  //   user?.LocationKey,
  //   user?.UserKey,
  // ]);

  useEffect(() => {
    if (isMenuUploaded) {
      setTimeout(() => {
        dispatch({ type: BULK_UPLOAD_RESET });
        window.location.reload();
      }, 3000);
      //  console.log("BULK MENU UPLOADED");
      //<Alert severity="success">Menu Uploaded</Alert>

      // dispatch({ type: BULK_UPLOAD_RESET_PARTNER });
      // history.push("/BLXOrderHub/menus");
      //window.location.reload();
      // return <Redirect to="/BLXOrderHub/menus" />;
    }

    if (isMenuUpdated) {
      //  console.log("redirecting to menu page");
      // history.push("/BLXOrderHub/menus")

      setTimeout(() => {
        dispatch({ type: UPDATE_ITEM_RESET });
        window.location.reload();
      }, 3000);

      // return <Redirect to="/BLXOrderHub/menus" />;
    }

    if (updateFailed) {
      setTimeout(() => {
        dispatch({ type: UPDATE_ITEM_RESET });
      }, 5000);
    }

    if (isUploadFailed) {
      setTimeout(() => {
        dispatch({ type: BULK_UPLOAD_RESET });
      }, 5000);
    }
  }, [
    isMenuUploaded,
    isMenuUpdated,
    dispatch,
    history,
    isMenuUploading,
    isUploadFailed,
    updateFailed,
  ]);
  //useeffect start
  useEffect(() => {
    filterMenuToUpload();
  }, []);

  // const menuItems:{ id: string, name: string,price:string,image:string,inStock:any }[] = [
  //   {
  //     id:"1",
  //     name: "Burger",
  //     price:"200",
  //     image:"https://img.traveltriangle.com/blog/wp-content/uploads/2018/12/cover-for-street-food-in-sydney.jpg",
  //     inStock: 0
  //   },
  //   {
  //     id:"2",
  //     name: "Fried rice",
  //     price:"200",
  //      image:"https://img.traveltriangle.com/blog/wp-content/uploads/2018/12/cover-for-street-food-in-sydney.jpg",
  //      inStock: 1
  //   },
  //   {
  //     id:"3",
  //     name: "Noodles",
  //     price:"200",
  //      image:"https://img.traveltriangle.com/blog/wp-content/uploads/2018/12/cover-for-street-food-in-sydney.jpg",
  //      inStock:1
  //   },
  //   {
  //     id:"4",
  //     name: "Soup",
  //     price:"200",
  //      image:"https://img.traveltriangle.com/blog/wp-content/uploads/2018/12/cover-for-street-food-in-sydney.jpg",
  //      inStock: 0
  //   },{
  //     id:"5",
  //     name: "Desert",
  //     price:"200",
  //      image:"https://img.traveltriangle.com/blog/wp-content/uploads/2018/12/cover-for-street-food-in-sydney.jpg",
  //      inStock:0
  //   }

  // ]

  // const [selectedNavItem, setSelectedNavItem] = useState<any>(navItems[0]);
  // const [checked, setChecked] = React.useState(["wifi"]);

  // const handleToggle = (value: string) => () => {
  //   const currentIndex = checked.indexOf(value);
  //   const newChecked = [...checked];

  //   if (currentIndex === -1) {
  //     newChecked.push(value);
  //   } else {
  //     newChecked.splice(currentIndex, 1);
  //   }

  //   setChecked(newChecked);
  // };

  const handleIsAllSeleted = (e: any) => {
    // let val = e.target.checked;
    //console.log("all select clicked")
    //let allMenuList: any = [];
    const { checked } = e.target;
    setIsAllSelected(checked);
    // console.log(checked);

    //  setTodo((todos) =>
    //   todos.map((todo) => ({
    //     ...todo,
    //     completed: checked,
    //   }))
    // );

    setitemsToDisplay((items: IPartnerMenuItem[] | undefined) =>
      items?.map((item: IPartnerMenuItem) => ({
        ...item,
        IsPartnerItem: checked,
      }))
    );

    //     if (val === true) {

    //         //const element = array[index];
    //         if (itemsToDisplay.length > 0) {
    //       for (let index = 0; index < itemsToDisplay.length; index++) {
    //         let newItem: IPartnerMenuItem = {
    //           ItemKey: itemsToDisplay[index].ItemKey,
    //           ItemName: itemsToDisplay[index].ItemName,
    //           ItemCode: itemsToDisplay[index].ItemCode,
    //           ItemShortName: itemsToDisplay[index].ItemShortName,
    //           CategoryName: itemsToDisplay[index].CategoryName,
    //           CategoryCode: itemsToDisplay[index].CategoryCode,
    //           ItemImageUrl: itemsToDisplay[index].ItemImageUrl,
    //           ItemImage: null,
    //           Description: itemsToDisplay[index].Description,
    //           SalesPrice: itemsToDisplay[index].SalesPrice,
    //           IsDiscontinued: itemsToDisplay[index].IsDiscontinued,
    //           IsAgeVerification: itemsToDisplay[index].IsAgeVerification,
    //           IsPartnerItem: true,
    //         };

    //         allMenuList.push(newItem);

    //         //console.log("pushed")
    //       }
    //       setitemsToDisplay(allMenuList)
    //       console.log("all true")
    //        console.log(allMenuList)
    //         console.log(itemsToDisplay)

    //       }
    //     }else if(val === false){
    //  if (itemsToDisplay.length > 0) {
    //       for (let index = 0; index < itemsToDisplay.length; index++) {
    //         let newItem: IPartnerMenuItem = {
    //           ItemKey: itemsToDisplay[index].ItemKey,
    //           ItemName: itemsToDisplay[index].ItemName,
    //           ItemCode: itemsToDisplay[index].ItemCode,
    //           ItemShortName: itemsToDisplay[index].ItemShortName,
    //           CategoryName: itemsToDisplay[index].CategoryName,
    //           CategoryCode: itemsToDisplay[index].CategoryCode,
    //           ItemImageUrl: itemsToDisplay[index].ItemImageUrl,
    //           ItemImage: null,
    //           Description: itemsToDisplay[index].Description,
    //           SalesPrice: itemsToDisplay[index].SalesPrice,
    //           IsDiscontinued: itemsToDisplay[index].IsDiscontinued,
    //           IsAgeVerification: itemsToDisplay[index].IsAgeVerification,
    //           IsPartnerItem: false,
    //         };

    //         allMenuList.push(newItem);

    //         //console.log("pushed")
    //       }
    //       setitemsToDisplay(allMenuList)
    //       console.log("all false")
    //        console.log(allMenuList)
    //         console.log(itemsToDisplay)

    //       }

    //     }
    //console.log(val)
    // setIsAllSelected(val);
    // if (val === false) {
    //   window.location.reload();
    // }

    // if (val === true) {
    //   setIsAllSelected(true)
    //   console.log(isAllSelected)
    // }else{
    //   setIsAllSelected(false)
    //   console.log(isAllSelected)

    // }
  };

  const handleDiscontinueChange = (
    e: any,
    item: IPartnerMenuItem,
    itemCode: any
  ) => {
    const { checked } = e.target;

    if (updateItemList.includes(item.ItemCode)) {
      //console.log("has");
      setupdateItemList(
        updateItemList.filter((singleItem: any) => singleItem !== item.ItemCode)
      );
    } else {
      //console.log("add");
      setupdateItemList((prevLists: any) => [...prevLists, item.ItemCode]);
    }

    // let filteredMenu = menuItems.filter((items: IPartnerMenuItem) => {
    //   return items.ItemCode === item.ItemCode;
    // });

    // if (filteredMenu[0].IsDiscontinued !== checked) {

    //   setItemCodeDiscontinue(item.ItemCode);
    //   setupdateItemList((prevLists: any) => [...prevLists, itemCode]);

    // } else {

    //   setItemCodeDiscontinue("");

    //   let targetIndex = updateItemList.indexOf(itemCode);
    //   updateItemList.splice(targetIndex, 1);

    // }

    // if (item.IsDiscontinued === checked) {
    //   setItemCodeDiscontinue(item.ItemCode);
    // } else {
    //   setItemCodeDiscontinue("");
    // }
    // console.log(checked);
    // console.log(item.ItemCode);
    setitemsToDisplay((items: any) =>
      items.map((singleItem: any) =>
        singleItem.ItemCode === item.ItemCode
          ? {
              ...singleItem,
              IsDiscontinued: checked,
            }
          : singleItem
      )
    );

    //setItemCodeDiscontinue(item.ItemCode);
    // if (checked) {
    //   setItemCodeDiscontinue(item.ItemCode);
    // } else if (!checked) {
    //   setItemCodeDiscontinue("");
    // }
    // setItemCodeDiscontinue(item.ItemCode);
    // if (discontinueChanged === false) {
    //   setdiscontinueChanged(true);
    //   setItemCodeDiscontinue(item.ItemCode);
    //   console.log(itemsToDisplay);
    // } else {
    //   setdiscontinueChanged(false);
    //   setItemCodeDiscontinue("");
    // }
    // console.log("change")
    //  let value = e.target.checked
    //console.log(value)
    //  setdiscontinueChanged(!discontinueChanged);
    //  console.log(discontinueChanged);

    //console.log(discontinueChanged)
  };

  const handlePartnerChange = (
    e: any,
    itemCode: string,
    item: IPartnerMenuItem
  ) => {
    //  console.log("change");
    // let value = e.target.checked;
    // console.log(value)

    const { checked } = e.target;
    // console.log(checked);

    setitemsToDisplay((items: IPartnerMenuItem[] | undefined) =>
      items?.map((singleItem: IPartnerMenuItem) =>
        singleItem.ItemCode === item.ItemCode
          ? {
              ...singleItem,
              IsPartnerItem: checked,
            }
          : singleItem
      )
    );

    //     if (value) {
    //       for (let index = 0; index < itemsToDisplay.length; index++) {
    //        if (itemsToDisplay[index].ItemCode === item.ItemCode) {

    //         console.log(itemsToDisplay[index].ItemCode)
    //         console.log(item.ItemCode)
    // console.log("deleting")
    //         itemsToDisplay.splice(index, 1);

    // console.log("making item false")
    //         let newItem: IPartnerMenuItem = {
    //         ItemKey: item.ItemKey,
    //         ItemName: item.ItemName,
    //         ItemCode: item.ItemCode,
    //         ItemShortName: item.ItemShortName,
    //         CategoryName: item.CategoryName,
    //         CategoryCode: item.CategoryCode,
    //         ItemImageUrl: item.ItemImageUrl,
    //         ItemImage: null,
    //         Description: item.Description,
    //         SalesPrice: item.SalesPrice,
    //         IsDiscontinued: item.IsDiscontinued,
    //         IsAgeVerification: item.IsAgeVerification,
    //         IsPartnerItem: true,
    //       };
    // console.log("adding false item")
    //       itemsToDisplay.splice(index, 0, newItem);
    //       console.log("added false item")
    //        }

    //       }

    //     } else {

    //       for (let index = 0; index < itemsToDisplay.length; index++) {
    //         if (itemsToDisplay[index].ItemCode === item.ItemCode) {

    //         console.log(itemsToDisplay[index].ItemCode)
    //         console.log(item.ItemCode)
    // console.log("deleting")
    //         itemsToDisplay.splice(index, 1);

    // console.log("making item true")
    //         let newItem: IPartnerMenuItem = {
    //         ItemKey: item.ItemKey,
    //         ItemName: item.ItemName,
    //         ItemCode: item.ItemCode,
    //         ItemShortName: item.ItemShortName,
    //         CategoryName: item.CategoryName,
    //         CategoryCode: item.CategoryCode,
    //         ItemImageUrl: item.ItemImageUrl,
    //         ItemImage: null,
    //         Description: item.Description,
    //         SalesPrice: item.SalesPrice,
    //         IsDiscontinued: item.IsDiscontinued,
    //         IsAgeVerification: item.IsAgeVerification,
    //         IsPartnerItem: false,
    //       };
    // console.log("adding true item")
    //       itemsToDisplay.splice(index, 0, newItem);
    //       console.log("added true item")
    //        }

    //       }

    //     }

    //  if (partnerChanged === false) {
    //    setItemCode(itemCode)
    //    setpartnerChanged(true)
    //  }else{
    //    setpartnerChanged(false);

    //   setItemCode("")
    //  }

    // console.log(partnerChanged)
    // if (partnerChanged) {
    //   console.log("changed")
    //   setItemCode(itemCode)
    // }else{
    //   console.log("notchanged")
    //   setItemCode("")
    // }

    //  console.log(itemCode)
  };
  const setProducts = () => {
    const data: { columns: any; rows: any } = {
      columns: [
        {
          label: "Item Image",
          field: "ItemImage",
          sort: "asc",
          width: 50,
        },
        {
          label: "Item Code",
          field: "ItemCode",
          sort: "asc",
          width: 50,
        },
        {
          label: "Item Name",
          field: "ItemShortName",
          sort: "asc",
          width: 50,
        },
        {
          label: "Category",
          field: "CategoryName",
          sort: "asc",
          width: 50,
        },

        {
          label: "Sales Price",
          field: "SalesPrice",
          sort: "asc",
          width: 50,
        },
        {
          label: "Sold Out",
          field: "IsDiscontinued",
          sort: "asc",
          width: 50,
        },
        {
          label: (
            <>
              <p>Is Partner Item</p>
              <label
                className={isAllSelected ? styles.switch_on : styles.switch}
              >
                <input
                  type="checkbox"
                  onChange={(e) => handleIsAllSeleted(e)}
                  className={isAllSelected ? styles.switch_on : styles.switch}
                />
                <div></div>
              </label>
            </>
          ),
          field: "IsPartnerItem",
          sort: "asc",
          width: 50,
        },
        {
          label: "Action",
          field: "action",
          width: 50,
        },
      ],
      rows: [],
    };

    itemsToDisplay !== undefined &&
      itemsToDisplay.forEach((item: IPartnerMenuItem) => {
        //setisPartnerAvailable(item.IsPartnerItem)
        //setisDiscontinuedItem(item.IsDiscontinued)
        //   if (item.ItemImageUrl !== null) {
        //  console.log(item.ItemImageUrl);
        //   }
        //   console.log(item.ItemImageUrl);
        //const price = item.SalesPrice.toFixed(2)
        // console.log(price)
        data.rows.push({
          ItemImage:
            item.ItemImageUrl === null ? (
              <p>No Image</p>
            ) : (
              <img
                alt={`${item.CategoryName}`}
                src={`data:image/jpeg;base64,${item.ItemImage}`}
                // src={item.ItemImage}
                style={{ height: "50px", width: "50px" }}
              />
              // <p>{item.ItemImageUrl}</p>
            ),
          ItemCode: item.ItemCode,
          CategoryName:
            item.CategoryName === null ? <p>No Data</p> : item.CategoryName,
          ItemShortName:
            item.ItemShortName === null ? <p>No Data</p> : item.ItemShortName,
          // IsDiscontinued: item.IsDiscontinued ? (
          //   <form>
          //     <input
          //       disabled={
          //         (discontinueChanged && item.ItemCode !== itemCodeDiscontinue) ||
          //         item.IsPartnerItem === false
          //           ? true
          //           : false
          //       }
          //       type="checkbox"
          //       defaultChecked
          //       value={item.IsDiscontinued}
          //       onClick={(e) => handleDiscontinueChange(e, item.ItemCode)}
          //     />{" "}
          //   </form>
          // ) : (
          //   <form>
          //     <input
          //       disabled={
          //         (discontinueChanged && item.ItemCode !== itemCodeDiscontinue) ||
          //         item.IsPartnerItem === false
          //           ? true
          //           : false
          //       }
          //       type="checkbox"
          //       value={item.IsDiscontinued}
          //       onClick={(e) => handleDiscontinueChange(e, item.ItemCode)}
          //     />{" "}
          //   </form>
          // ),
          IsDiscontinued: (
            <label
              className={item.IsDiscontinued ? styles.switch_on : styles.switch}
            >
              <input
                checked={item.IsDiscontinued}
                // disabled={
                //   (discontinueChanged && item.ItemCode !== itemCodeDiscontinue) ||
                //   item.IsPartnerItem === false
                //     ? true
                //     : false
                // }
                type="checkbox"
                onChange={(e) =>
                  handleDiscontinueChange(e, item, item.ItemCode)
                }
              />
              <div></div>
            </label>
          ),
          IsPartnerItem: (
            <label
              className={item.IsPartnerItem ? styles.switch_on : styles.switch}
            >
              <input
                type="checkbox"
                checked={item.IsPartnerItem}
                onChange={(e) => handlePartnerChange(e, item.ItemCode, item)}
              />
              <div></div>
            </label>
          ),
          // item.IsPartnerItem  ? (
          //   <input
          //     // disabled={partnerChanged && item.ItemCode !== itemCode ? true : false}
          //     type="checkbox"
          //     defaultChecked
          //     value={item.IsPartnerItem}
          //     onClick={(e) => handlePartnerChange(e, item.ItemCode, item)}
          //   />
          // ) : (
          //   <input
          //     //  disabled={partnerChanged && item.ItemCode !== itemCode ? true : false}
          //     type="checkbox"
          //     value={item.IsPartnerItem}
          //     onClick={(e) => handlePartnerChange(e, item.ItemCode, item)}
          //   />
          // ),
          SalesPrice:
            item.OptionalSalesPrice === null ? (
              <p>No Data</p>
            ) : (
              item.OptionalSalesPrice.toFixed(2)
            ),
          action: (
            <>
              {updateItemList.includes(item.ItemCode) ? (
                <>
                  <Button
                    variant="contained"
                    startIcon={<UpgradeOutlined />}
                    onClick={() =>
                      updateMenuItem(
                        item.ItemKey,
                        item.ItemCode,
                        item.SalesPrice,
                        item.OptionalSalesPrice,
                        item.IsDiscontinued,
                        item.IsPartnerItem
                      )
                    }
                  >
                    Update
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    variant="outlined"
                    startIcon={<UpgradeOutlined />}
                    disabled
                    onClick={() =>
                      updateMenuItem(
                        item.ItemKey,
                        item.ItemCode,
                        item.SalesPrice,
                        item.OptionalSalesPrice,
                        item.IsDiscontinued,
                        item.IsPartnerItem
                      )
                    }
                  >
                    Update
                  </Button>
                </>
              )}
            </>
          ),
          // IsDiscontinued: item.IsDiscontinued ? <ToggleOn handleClick={()=>updateMenuItem(item.ItemKey,item.ItemCode,item.SalesPrice)}/> : <ToggleOff handleClick={()=>updateMenuItem(item.ItemKey,item.ItemCode,item.SalesPrice)}/>,
          // IsPartnerItem: item.IsPartnerItem ? <ToggleOn handleClick={()=>console.log(item.ItemCode)}/> :<ToggleOff handleClick={()=>{console.log(item.ItemCode)}}/>,
          //                  IsDiscontinued : item.IsDiscontinued ?
          //                  <form className={styles.center_items}>
          //                    <>
          //     <label className={styles.switch}>
          //     <input type="checkbox" defaultChecked={item.IsDiscontinued}  onClick={(e)=>handleDiscontinueChange(e)}/>
          //     <div>
          //       <span></span>
          //     </div>
          // </label>
          //                 </>
          //                  </form>
          //                 : <form>
          //                    <>
          //     <label className={styles.switch}>
          //     <input type="checkbox"   onClick={(e)=>handleDiscontinueChange(e)}/>
          //     <div>
          //       <span></span>
          //     </div>
          // </label>
          //                 </>
          //                 </form>,
          //                 IsDiscontinued :  <>
          //     <label className={styles.switch}>
          //     <input type="checkbox" defaultChecked />
          //     <div>
          //       <span></span>
          //     </div>
          // </label>
          //                 </> ,
        });
      });

    return data;
  };

  const uploadMenuHandler = async () => {
    setisProcessing(true);

    const modifiedItems = itemsToDisplay?.map((item: IPartnerMenuItem) => ({
      ...item,
      ItemImage: "",
    }));

    const filteredMenuItemsList = modifiedItems?.filter(
      (x) => x.IsPartnerItem && !x.IsDiscontinued
    );
    //const loopCount = filteredMenuItemsList?.length ?? 0;

    /*const dataSignal: IBaseModel = {
      RequestId: API_INTEGRATION_ID,
      IntegrationId: API_INTEGRATION_ID,
      ApiKey: "",
      UID: {
        CompanyKey: user?.CompanyKey ?? 0,
        LocationKey: user?.LocationKey ?? 0,
        UserKey: user?.UserKey ?? 0,
        EnvironmentName: user?.EnvironmentName ?? 0,
      },
      RequestingUser: 0,
      RequestingId: "",
      Schema: "",
      ValidationMessages: [],
      IsApprovedStatus: 0,
      IsActive: 0,
    };*/

    setisProcessing(false);
    //let newList = [];
    //console.log(modifiedItems);

    /* if (modifiedItems !== undefined && modifiedItems.length > 100) {
      while (modifiedItems.length !== 0) {
        const firstNItems = modifiedItems.splice(0, 100);
        //console.log(firstNItems);
        const dataToUpload: IPartnerMenuItemRequestModel = {
          IsSpecialInstructionEnable: false,
          PartnerMenuItemList: firstNItems ?? undefined,
          RequestId: API_INTEGRATION_ID,
          IntegrationId: API_INTEGRATION_ID,
          ApiKey: "",
          UID: {
            CompanyKey: user?.CompanyKey ?? 0,
            LocationKey: user?.LocationKey ?? 0,
            UserKey: user?.UserKey ?? 0,
            EnvironmentName: user?.EnvironmentName ?? 0,
          },
          RequestingUser: 0,
          RequestingId: "",
          Schema: "",
          ValidationMessages: [],
          IsApprovedStatus: 0,
          IsActive: 0,
          FilteredMenuItemCount: filteredMenuItemsList?.length ?? 0,
        };

        dispatch(
          uploadBulkMenu(dataToUpload, Math.ceil(loopCount / 100), dataSignal)
        );
      }
    } else { */
    if (modifiedItems !== undefined) {
      const dataToUpload: IPartnerMenuItemRequestModel = {
        IsSpecialInstructionEnable: false,
        PartnerMenuItemList: modifiedItems ?? undefined,
        RequestId: API_INTEGRATION_ID,
        IntegrationId: API_INTEGRATION_ID,
        ApiKey: "",
        UID: {
          CompanyKey: user?.CompanyKey ?? 0,
          LocationKey: user?.LocationKey ?? 0,
          UserKey: user?.UserKey ?? 0,
          EnvironmentName: user?.EnvironmentName ?? 0,
          IsUrbanPiper: user?.IsUrbanPiper ?? false,
        },
        RequestingUser: 0,
        RequestingId: "",
        Schema: "",
        ValidationMessages: [],
        IsApprovedStatus: 0,
        IsActive: 0,
        FilteredMenuItemCount: filteredMenuItemsList?.length ?? 0,
      };

      dispatch(uploadBulkMenu(dataToUpload));
    }
    //}

    //  setitemsToDisplay((items:any)=>
    //   items.map((item:any)=>({
    //     ...item,
    //     ItemImage:null
    //   })))

    //  await itemsToDisplay.forEach((x:any)=>{x.ItemImage = null
    //   console.log(x.ItemImage)
    //   })
    //setitemsToUpload(itemsToDisplay)

    // console.log("itemsToUpload after making null")
    // console.log(modifiedItems)

    /*     const partnerUpload: IPartnerMenuItemRequestModel = {
      IsSpecialInstructionEnable: false,
      PartnerMenuItemList: [],
      RequestId: API_INTEGRATION_ID,
      IntegrationId: API_INTEGRATION_ID,
      ApiKey: "",
      UID: {
        CompanyKey: user?.CompanyKey ?? 0,
        LocationKey: user?.LocationKey ?? 0,
        UserKey: user?.UserKey ?? 0,
        EnvironmentName: user?.EnvironmentName ?? 0,
      },
      RequestingUser: 0,
      RequestingId: "",
      Schema: "",
      ValidationMessages: [],
      IsApprovedStatus: 0,
      IsActive: 0,
    }; */
    //console.log("dataToUpload");
    //console.log(modifiedItems);
    //dispatch(uploadBulkMenuToPartner(partnerUpload));

    // if (isAllSelected === true) {
    //   setisUploading(true);
    //   let allMenuList: any = [];
    //   const baseModel: IBaseModel = {
    //     RequestId: API_INTEGRATION_ID,
    //     IntegrationId: API_INTEGRATION_ID,
    //     ApiKey: "",
    //   UID: {
    //     CompanyKey: user?.CompanyKey ?? 0,
    //     LocationKey: user?.LocationKey ?? 0,
    //     UserKey: user?.UserKey ?? 0,
    //   },
    //     RequestingUser: 0,
    //     RequestingId: "",
    //     Schema: "",
    //     ValidationMessages: [],
    //     IsApprovedStatus: 0,
    //     IsActive: 0,
    //   };

    //   const { ResponseData } = await apis.Menus.getMenuItemList(baseModel);

    //   if (ResponseData.MenuItemList.length > 0) {
    //     for (let index = 0; index < ResponseData.MenuItemList.length; index++) {
    //       let newItem: IPartnerMenuItem = {
    //         ItemKey: ResponseData.MenuItemList[index].ItemKey,
    //         ItemName: ResponseData.MenuItemList[index].ItemName,
    //         ItemCode: ResponseData.MenuItemList[index].ItemCode,
    //         ItemShortName: ResponseData.MenuItemList[index].ItemShortName,
    //         CategoryName: ResponseData.MenuItemList[index].CategoryName,
    //         CategoryCode: ResponseData.MenuItemList[index].CategoryCode,
    //         ItemImageUrl: ResponseData.MenuItemList[index].ItemImageUrl,
    //         ItemImage: null,
    //         Description: ResponseData.MenuItemList[index].Description,
    //         SalesPrice: ResponseData.MenuItemList[index].SalesPrice,
    //         IsDiscontinued: ResponseData.MenuItemList[index].IsDiscontinued,
    //         IsAgeVerification:
    //           ResponseData.MenuItemList[index].IsAgeVerification,
    //         IsPartnerItem: true,
    //       };

    //       allMenuList.push(newItem);
    //     }
    //   }

    //   setisUploading(false);

    //   const data: IPartnerMenuItemRequestModel = {
    //     IsSpecialInstructionEnable: false,
    //     PartnerMenuItemList: allMenuList,
    //     RequestId: API_INTEGRATION_ID,
    //     IntegrationId: API_INTEGRATION_ID,
    //     ApiKey: "",
    //   UID: {
    //     CompanyKey: user?.CompanyKey ?? 0,
    //     LocationKey: user?.LocationKey ?? 0,
    //     UserKey: user?.UserKey ?? 0,
    //   },
    //     RequestingUser: 0,
    //     RequestingId: "",
    //     Schema: "",
    //     ValidationMessages: [],
    //     IsApprovedStatus: 0,
    //     IsActive: 0,
    //   };
    //   //console.log("allMenuList");
    //   //console.log(data);
    //   dispatch(uploadBulkMenu(data));
    // } else {
    //   const data: IPartnerMenuItemRequestModel = {
    //     IsSpecialInstructionEnable: false,
    //     PartnerMenuItemList: bulkUpload,
    //     RequestId: API_INTEGRATION_ID,
    //     IntegrationId: API_INTEGRATION_ID,
    //     ApiKey: "",
    //   UID: {
    //     CompanyKey: user?.CompanyKey ?? 0,
    //     LocationKey: user?.LocationKey ?? 0,
    //     UserKey: user?.UserKey ?? 0,
    //   },
    //     RequestingUser: 0,
    //     RequestingId: "",
    //     Schema: "",
    //     ValidationMessages: [],
    //     IsApprovedStatus: 0,
    //     IsActive: 0,
    //   };
    //   // console.log(data);
    //   dispatch(uploadBulkMenu(data));
    //   //  setisUploading(true);
    // }
  };

  const updateMenuItem = (
    itemKey: number,
    itemCode: string,
    price: number,
    optionalprice: number,
    isDiscontinued: boolean,
    isPartner: boolean
  ) => {
    // if (discontinueChanged) {
    //   // console.log(isDiscontinued);

    // }

    const updateModel: IPartnerMenuItemUpdateRequestModel = {
      ItemKey: itemKey,
      ItemCode: itemCode,
      IsDiscontinued: isDiscontinued,
      IsPartnerItem: isPartner,
      SalesPrice: price,
      OptionalSalesPrice: optionalprice,

      RequestId: API_INTEGRATION_ID,
      IntegrationId: API_INTEGRATION_ID,
      ApiKey: "",
      UID: {
        CompanyKey: user?.CompanyKey ?? 0,
        LocationKey: user?.LocationKey ?? 0,
        UserKey: user?.UserKey ?? 0,
        EnvironmentName: user?.EnvironmentName ?? 0,
        IsUrbanPiper: user?.IsUrbanPiper ?? false,
      },
      RequestingUser: 0,
      RequestingId: "",
      Schema: "",
      ValidationMessages: [],
      IsApprovedStatus: 0,
      IsActive: 0,
    };
    //console.log(updateModel);
    dispatch(updateMenu(updateModel));
    //console.log(isDiscontinued)
    //console.log(isPartner)
    // console.log("discontinueChanged")
    // console.log(discontinueChanged)

    //  console.log("partnerChanged")
    // console.log(partnerChanged)

    // console.log("--------------------------------")

    // if (partnerChanged && discontinueChanged) {
    //   console.log("both true");
    //   console.log(discontinueChanged);
    //   console.log(partnerChanged);

    //   const updateModel: IPartnerMenuItemUpdateRequestModel = {
    //     ItemKey: itemKey,
    //     ItemCode: itemCode,
    //     IsDiscontinued: !isDiscontinued,
    //     IsPartnerItem: !isPartner,
    //     SalesPrice: price,
    //     RequestId: API_INTEGRATION_ID,
    //     IntegrationId: API_INTEGRATION_ID,
    //     ApiKey: "",
    //     ApplicationId: "",
    //     LocationApiKey: "",
    //     RequestingUser: 0,
    //     RequestingId: "",
    //     Schema: "",
    //     ValidationMessages: [],
    //     IsApprovedStatus: 0,
    //     IsActive: 0,
    //   };
    //   console.log(updateModel);
    //   dispatch(updateMenu(updateModel));
    // } else if (partnerChanged && !discontinueChanged) {
    //   console.log("partner change true, discon false");
    //   console.log(discontinueChanged);
    //   console.log(partnerChanged);

    //   const updateModel: IPartnerMenuItemUpdateRequestModel = {
    //     ItemKey: itemKey,
    //     ItemCode: itemCode,
    //     IsDiscontinued: isDiscontinued,
    //     IsPartnerItem: !isPartner,
    //     SalesPrice: price,
    //     RequestId: API_INTEGRATION_ID,
    //     IntegrationId: API_INTEGRATION_ID,
    //     ApiKey: "",
    //     ApplicationId: "",
    //     LocationApiKey: "",
    //     RequestingUser: 0,
    //     RequestingId: "",
    //     Schema: "",
    //     ValidationMessages: [],
    //     IsApprovedStatus: 0,
    //     IsActive: 0,
    //   };
    //   console.log(updateModel);
    //   dispatch(updateMenu(updateModel));
    // } else if (!partnerChanged && discontinueChanged) {
    //   console.log("partner change false, discon true");
    //   console.log(discontinueChanged);
    //   console.log(partnerChanged);

    //   const updateModel: IPartnerMenuItemUpdateRequestModel = {
    //     ItemKey: itemKey,
    //     ItemCode: itemCode,
    //     IsDiscontinued: !isDiscontinued,
    //     IsPartnerItem: isPartner,
    //     SalesPrice: price,
    //     RequestId: API_INTEGRATION_ID,
    //     IntegrationId: API_INTEGRATION_ID,
    //     ApiKey: "",
    //     ApplicationId: "",
    //     LocationApiKey: "",
    //     RequestingUser: 0,
    //     RequestingId: "",
    //     Schema: "",
    //     ValidationMessages: [],
    //     IsApprovedStatus: 0,
    //     IsActive: 0,
    //   };
    //   console.log(updateModel);
    //   dispatch(updateMenu(updateModel));
    // } else {
    //   console.log("both false");
    //   console.log(discontinueChanged);
    //   console.log(partnerChanged);
    //   const updateModel: IPartnerMenuItemUpdateRequestModel = {
    //     ItemKey: itemKey,
    //     ItemCode: itemCode,
    //     IsDiscontinued: isDiscontinued,
    //     IsPartnerItem: isPartner,
    //     SalesPrice: price,
    //     RequestId: API_INTEGRATION_ID,
    //     IntegrationId: API_INTEGRATION_ID,
    //     ApiKey: "",
    //     ApplicationId: "",
    //     LocationApiKey: "",
    //     RequestingUser: 0,
    //     RequestingId: "",
    //     Schema: "",
    //     ValidationMessages: [],
    //     IsApprovedStatus: 0,
    //     IsActive: 0,
    //   };
    //   console.log(updateModel);
    //  dispatch(updateMenu(updateModel));
    // }

    // console.log(itemCode)
    // console.log(itemKey)
    // console.log(price)
    // console.log("isDiscontinuedItem")
    // console.log(isDiscontinuedItem)
    // console.log("isPartnerAvailable")
    // console.log(isPartnerAvailable)

    // const  updateModel:IPartnerMenuItemUpdateRequestModel={
    //   ItemKey: itemKey,
    //   ItemCode: itemCode,
    //   IsDiscontinued: isDiscontinued === isDiscontinuedItem ? isDiscontinued : isDiscontinuedItem,
    //   IsPartnerItem: isPartner === isPartnerAvailable ? isPartner : isPartnerAvailable,
    //   SalesPrice: price,
    //   RequestId: API_INTEGRATION_ID,
    //   IntegrationId: API_INTEGRATION_ID,
    //   ApiKey: "",
    //   ApplicationId: "",
    //   LocationApiKey: "",
    //   RequestingUser: 0,
    //   RequestingId: "",
    //   Schema: "",
    //   ValidationMessages: [],
    //   IsApprovedStatus: 0,
    //   IsActive: 0
    // }

    // dispatch(updateMenu(updateModel))
  };

  return (
    <div className={styles.main_wrapper}>
      {/* update related responses */}
      {updateFailed && <Alert severity="error">Update failed</Alert>}
      {isMenuUpdated && (
        <Alert severity="success">Menu updated successfully</Alert>
      )}

      {/* upload related responses */}
      {isMenuUploaded && (
        <Alert severity="success">Menu uploaded successfully</Alert>
      )}
      {isUploadFailed && <Alert severity="error">Menu upload failed</Alert>}

      <div className={styles.menu_header}>
        Menu Items
        <div className={styles.button_container}>
          {isItemsLoading === false && (
            <button className={styles.menu_upload} onClick={uploadMenuHandler}>
              Sync items
            </button>
          )}
        </div>
      </div>
      {/* <div className={styles.select_all_checkbox}>
          <input type="checkbox"  onChange={(e)=>handleIsAllSeleted(e)}/>
        </div>
        <div className={styles.padding_div}></div> */}
      <div className={styles.menu_box}>
        {/* <div className={styles.nav_header}>
          <div className={styles.nav_items}>
            {navItems !== [] &&
              navItems.map((orderType: any) => (
                <div
                  key={v4()}
                  className={cx(
                    styles.nav_item,
                    selectedNavItem.orderType === orderType.orderType &&
                      styles.nav_item_selected
                  )}
                  onClick={() => setSelectedNavItem(orderType)}
                >
                  {orderType.orderTypeName}
                </div>
              ))}
          </div>
        </div> */}
        {/* <hr /> */}
        {/* <CardContent>
          <List sx={{ width: "100%", bgcolor: "background.paper" }}>
            <ListItem>
              <ListItemIcon></ListItemIcon>
              <ListItemText
                id="switch-list-label-wifi"
                primary="Enable Customer to put Special Instructions on Items in Uber"
              />
              <Switch
                edge="end"
                onChange={handleToggle("wifi")}
                checked={checked.indexOf("wifi") !== -1}
                inputProps={{
                  "aria-labelledby": "switch-list-label-wifi",
                }}
              />
            </ListItem>
          </List>
          
        </CardContent> */}
        {/* <button onClick={getMenuHandler}>Get menu</button> */}

        {/* {isUploading && (
          <>
            <LoadingComponent />
          </>
        )} */}
        {isItemsLoading ? (
          <>
            <LoadingComponent />
            {isItemsLoading}
          </>
        ) : (
          <>
            {" "}
            <MDBDataTable
              data={setProducts()}
              bordered
              disableRetreatAfterSorting
              searchLabel="Search by Item name"
              entrieslabel="Menu per page"
              //striped
              responsive
              hover
              noBottomColumns
              className={styles.data_table}
            />
          </>
        )}

        {isProcessing && (
          <>
            <div className={styles.popup_box}>
              <div className={styles.box}>
                {/* <CircularProgress/> */}
                <Spinner children="" type="grow" color="primary" />
                <p>Processing menu upload. Please wait!!!</p>
              </div>
            </div>
          </>
        )}
        {isMenuUploading && (
          <>
            <div className={styles.popup_box}>
              <div className={styles.box}>
                {/* <CircularProgress/> */}
                <Spinner children="" type="grow" color="primary" />
                <p>Uploading menu. Please wait!!!</p>
              </div>
            </div>
          </>
        )}

        {
          // isMenuUploadingPartner && (
          //   <>
          //     <div className={styles.popup_box}>
          //       <div className={styles.box}>
          //         {/* <CircularProgress/> */}
          //         <Spinner children="" type="grow" color="primary" />
          //         <p>Uploading menu. Please wait!!!</p>
          //       </div>
          //     </div>
          //   </>
          // )
        }

        {isUpdating && (
          <>
            <div className={styles.popup_box}>
              <div className={styles.box}>
                {/* <CircularProgress/> */}
                <Spinner children="" type="grow" color="primary" />
                <p>Updating menu. Please wait!!!</p>
              </div>
            </div>
          </>
        )}

        {isMenuUploaded && (
          <Alert severity="success">
            <AlertTitle>Uploaded</AlertTitle>
          </Alert>
        )}

        {/* {
            toggleUberMenu && (<>
            <PartnerMenu handleClose={()=>settoggleUberMenu(false)}/>
            
            </>)
          } */}
      </div>
    </div>
  );
};

export default MenuPage;
